import { createSlice } from '@reduxjs/toolkit';
import {
  getUser,
} from '../thunk/userThunk';

const initialState = {
  userData: null,
  loading: false,
  error: null,
};

export const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default UserSlice.reducer;
